<template>
  <section>
    <modal-enviar-regulacao
      v-if="showModalEnviarRegulacao"
      @close="showModalEnviarRegulacao = false"
      @enviaRegulacao="(motivo) => enviaRegulacao(motivo)"
    ></modal-enviar-regulacao>
    <div class="nav-tabs-custom">
      <ul class="nav nav-tabs">
        <li class="active">
          <a href="#tab_1" data-toggle="tab">Selecione o atendimento</a>
        </li>
        <!-- <li><a href="#tab_2" data-toggle="tab">Por Profissional</a></li>
        <li><a href="#tab_3" data-toggle="tab">Por Data</a></li>-->
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="tab_1">
			<div style="text-align:right; margin-bottom:20px;z-index: 9999999">
				<button	@click="$router.go(-1)"	class="btn btn-default pull-left"><i class="fa fa-reply"></i> Voltar</button>
				<button	@click="confirma" v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-success"><i class="fa fa-check"></i> Confirmar </button>
				<button @click="informacaoPendente" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class='btn btn-info'><i class="fa fa-comment"></i> Solicitar informação pendente</button>
			  	<button @click="negativar" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class='btn btn-danger'><i class="fa fa-times-circle"></i> Negativar</button>
				<button	@click="confirma" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao"	class="btn btn-success"><i class="fa fa-check"></i> Regular</button>
				<button	@click="showModalEnviarRegulacao = true" v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao"	class="btn btn-warning"><i class="fa fa-send"></i> Regulação</button>
			</div>
          <div class="row">
            <div class="col-sm-6">
              <div class="divListVagas">
                <div class="panel panel-default panel-table listbox">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col col-xs-12">
                        <h3 class="panel-title">
                          <b>Selecione uma unidade</b>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ul class="listsVagas tamanho-fixo-agenda-cima">
                      <li
                        v-for="(item, index) in vagas_unidade"
                        :key="index"
                        @click="getProfissionaisAndDiasByUnidade(index, item[0].unidade_id)"
                      >
                        <a
                          :class="{'ativa': selecionados.indexUnidadeAtiva === index}"
                          class="list-group-item list-group-item-action list-group-item-warning"
                        >
                          <strong>{{item[0].unidade.nome | uppercase}}</strong>
                          <br />
                          <span
                            v-show="$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
                          >Atendimentos Disponíveis:
                           <strong v-if="$props.tipoVaga == 0"> {{  getQtdVagasPrimeira(item) }}</strong>
                           <strong v-if="$props.tipoVaga == 1"> {{  getQtdVagasRetorno(item) }}</strong>
                           <strong v-if="$props.tipoVaga == 2"> {{  getQtdVagasLocal(item) }}</strong>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="divListVagas">
                <div class="panel panel-default panel-table listbox">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col col-xs-12">
                        <h3 class="panel-title">
                          <b>Selecione um profissional</b>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ul class="listsVagas tamanho-fixo-agenda-cima">
                      <li
                        v-for="(item, index) in vagas_profissional"
                        :key="index"
                        @click="getDiasByUnidadeAndProfissional( index, item[0].profissional_id)"
                      >
                        <a
                          :class="{'ativa': selecionados.indexProfissionalAtivo === index}"
                          class="list-group-item list-group-item-action list-group-item-warning"
                        >
                          <strong>{{item[0].profissional.nome | uppercase }}</strong>
                          <br />
                          <span
                            v-show="$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'"
                          >Atendimentos Disponíveis:
                           <strong v-if="$props.tipoVaga == 0"> {{  getQtdVagasPrimeira(item) }}</strong>
                           <strong v-if="$props.tipoVaga == 1"> {{  getQtdVagasRetorno(item) }}</strong>
                           <strong v-if="$props.tipoVaga == 2"> {{  getQtdVagasLocal(item) }}</strong>
                        </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="divListVagas">
                <div class="panel panel-default panel-table">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col col-xs-12">
                        <h3 class="panel-title" style="cursor: pointer;">
                          <b>Selecione uma data</b>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div style="height: 260px;">
                    <date-picker
                      @dp-change="getProfissionaisByUnidadeAndDia"
                      v-if="optionsCalendario.enabledDates"
                      v-model="selecionados.data"
                      :config="optionsCalendario"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="divListVagas">
                <div class="panel panel-default panel-table listbox">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col col-xs-12">
                        <h3 class="panel-title">
                          <b>Atendimentos</b>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ul class="listsVagas tamanho-fixo-agenda-cima listbox">
                      <li
                        v-for="(item, index) in vagas_filtradas"
                        :key="index"
                        @click="selecionaVaga(index)"
                      >
                        <a
                          :class="{'ativa': selecionados.indexVagaAtiva === index}"
                          class="list-group-item list-group-item-action list-group-item-warning"
                        >
                          <strong>{{ item.unidade.nome | uppercase }}</strong>
                          <br />
                          <span>
                            <strong>Data:</strong>
                            {{ item.data_atendimento|dataFormatada }} à partir das
                            <b>{{ item.hora_inicial | horaFormatada }}</b> horas.
                          </span>
                          <br />
                          <span>
                            <strong>Profissional:</strong>
                            {{ item.profissional.nome }}
                          </span>
                          <br />
                          <span v-show="$store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador'">
                            <strong>Atendimentos Disponíveis:</strong>
                           <strong v-if="$props.tipoVaga == 0"> {{ item.quantidade_primeira }}</strong>
                           <strong v-if="$props.tipoVaga == 1"> {{ item.quantidade_retorno }}</strong>
                           <strong v-if="$props.tipoVaga == 2"> {{ item.quantidade_local }}</strong>
                          </span>
                          <div
                            class="row"
                            v-if="($store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador') && (idadePacienteSelecionado < item.idade_minima || idadePacienteSelecionado > item.idade_maxima)"
                          >
                            <div class="col-sm-12">
                              <span>
                                <strong>Idade Mínima:</strong>
                                {{ item.idade_minima }}
                              </span>
                              <br />
                              <span>
                                <strong>Idade Máxima:</strong>
                                {{ item.idade_maxima }}
                              </span>
                            </div>
                            <div class="col-sm-12">
                              <div class="alert alert-warning alert-dismissible">
                                <h4>
                                  <i class="icon fa fa-warning"></i> Atenção!
                                </h4>
                                A idade do paciente ({{ idadePacienteSelecionado }}) não obedece os limites do atendimento.
                              </div>
                            </div>
                          </div>
                           <p style="color: red" v-show="($store.state.user.nivel == 'regulador' || $store.state.user.nivel == 'administrador') && (item.cotaSolicitante == false || item.cotaPrestador == false || item.vagaPrestador == false)">
                            <strong>ATENÇÃO (EXTRAPOLAÇÃO): O atendimento selecionado possui as seguintes restrições: </strong>
                            <ul>
                              <li v-if="item.cotaSolicitante == false"><strong>Não há limite (cota) para a unidade solicitante!</strong></li>
                              <li v-if="item.cotaPrestador == false"><strong >Não há limite (cota) para a unidade prestadora!</strong></li>
                              <li v-if="item.vagaPrestador == false"><strong style="font-size: 30px; text-decoration: blink">Não há atendimento (vaga) disponível!</strong></li>
                            </ul>
                           </p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
		  <div style="text-align:right; margin-bottom:20px;z-index: 9999999">
			  <button
				  @click="confirma"
				  v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao"
				  class="btn btn-success"
			  >
				  <i class="fa fa-check"></i> Confirmar
			  </button>
			  <button @click="informacaoPendente" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class='btn btn-info'><i class="fa fa-comment"></i> Solicitar informação pendente</button>
			  <button @click="negativar" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class='btn btn-danger'><i class="fa fa-times-circle"></i> Negativar</button>
			  <button
				  @click="confirma"
				  v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao"
				  class="btn btn-success"
			  >
				  <i class="fa fa-check"></i> Regular
			  </button>
			  <button
				  @click="showModalEnviarRegulacao = true"
				  v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao"
				  class="btn btn-warning"
			  >
				  <i class="fa fa-send"></i> Regulação
			  </button>
		  </div>
      </div>
    </div>

  <div style="text-align:left; margin-bottom:20px;">
    <button
        @click="$router.go(-1)"
        class="btn btn-default"
      >
        <i class="fa fa-reply"></i> Voltar
      </button>
  </div>
  </section>
</template>

<script>
import groupBy from "json-groupby";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";
import { SITUACAO_SOLICITACAO } from "@/constants";
import modalEnviarRegulacao from "./modalEnviarRegulacao";

import axios from 'axios' // Cliente para requisição http

export default {
	props: ["vagasApi", "dataNascimentoPaciente", "tipoVaga", "solicitacaoId"],
	computed: {
		SITUACAO_SOLICITACAO: function() {
			return SITUACAO_SOLICITACAO;
		}
	},
    data: () => ({
        showModalEnviarRegulacao: false,
        idadePacienteSelecionado: 0,
        nomeBuscaUnidade: "",
        optionsCalendario: {
            format: "YYYY-MM-DD",
            useCurrent: false,
            inline: true,
            locale: "pt-br",
            enabledDates: null,
            defaultDate: false
        },
        filtros: {
            pesquisa: "",
            coluna: null,
            ordem: null
        },

        selecionados: {
            unidade_id: null,
            profissional_id: null,
            indexUnidadeAtiva: null,
            indexProfissionalAtivo: null,
            indexVagaAtiva: null,
            data: null
        },

        vagas_unidade: [],

        vagas_profissional: [],

        vagas_filtradas: [],

		vagas: [],
		dados: { observacao: '' },
    }),
    mounted() {},

    methods: {
        negativar() {
            this.$swal({
                title: `Justificativa da negativa:`,
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
				let loader = this.$loading.show()
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.$props.solicitacaoId;
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/negativar`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
							loader.hide()
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Solicitação negativada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-2);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        informacaoPendente() {
            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: `Mensagem para o marcador:`,
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.$props.solicitacaoId;
                if (result.value) {
					let loader = this.$loading.show()
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/atualizarSituacao`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
							loader.hide()
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Mensagem enviada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-2);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        confirma() {
            let vagaSelecionada = this.vagas_filtradas[this.selecionados.indexVagaAtiva];
            this.$emit("confirma", vagaSelecionada);
        },

        enviaRegulacao(motivo) {
            this.showModalEnviarRegulacao = false;
            let vagaSelecionada = this.vagas_filtradas[this.selecionados.indexVagaAtiva];
            this.$emit("enviaRegulacao", vagaSelecionada, motivo);
        },

        formataVagas: function() {
            let vagas = [];
            this.vagasApi.map(item => {
                vagas.push({
                    atendimento_id: item.id,
                    contrato_procedimento_id: item.distribuicao_contrato_procedimento_id,
                    quantidade_primeira: item.quantidade_primeira ? item.quantidade_primeira : item.quantidade_atendimento,
                    quantidade_retorno: item.quantidade_retorno ? item.quantidade_retorno : 0,
                    quantidade_local: item.quantidade_local ? item.quantidade_local : 0,
                    hora_inicial: item.hora_inicial,
                    hora_final: item.hora_final,
                    idade_minima: item.idade_minima,
                    idade_maxima: item.idade_maxima,
                    data_atendimento: item.data_atendimento,
                    profissional_id: item.profissional_id ? item.profissional_id : -1,
                    unidade_id: item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade_id : item.contrato_subgrupo.contrato.unidade_id,
                    profissional: {
                        nome: item.profissional_id ? item.profissional.nome : "SEM PROFISSIONAL"
                    },
                    unidade: {
                        nome: item.contrato_procedimento ? item.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo.contrato.unidade.nome
                    },
                    tipoVaga: item.contrato_procedimento ? "procedimento" : "subgrupo",
                    cotaSolicitante: item.cota_solicitante,
                    cotaPrestador: item.cota_prestador,
                    vagaPrestador: item.vaga_prestador
                });
            });

            this.vagas = vagas;
            this.vagas_unidade = groupBy(this.vagas, ["unidade_id"]);

            this.$nextTick(() => {
                this.getProfissionaisAndDiasByUnidade(String(vagas[0].unidade_id), vagas[0].unidade_id);
            });
        },

        getQtdVagasPrimeira: function(item) {
            let qtd = 0;
            item.map(function(obj) {
                qtd += obj.quantidade_primeira;
            });
            return qtd;
        },

        getQtdVagasRetorno: function(item) {
            let qtd = 0;
            item.map(function(obj) {
                qtd += obj.quantidade_retorno;
            });
            return qtd;
        },

        getQtdVagasLocal: function(item) {
            let qtd = 0;
            item.map(function(obj) {
                qtd += obj.quantidade_local;
            });
            return qtd;
        },

        getProfissionaisAndDiasByUnidade(index, unidadeId) {
            this.vagas_filtradas = [];
            this.selecionados.profissional_id = null;
            this.selecionados.indexProfissionalAtivo = null;
            this.selecionados.data = null;
            this.optionsCalendario.enabledDates = null;

            this.selecionados.unidade_id = unidadeId;
            this.selecionados.indexUnidadeAtiva = index;

            let profissionaisByUnidade = [];
            let diasByUnidade = [];
            this.vagas.map(item => {
                if (item.unidade_id == this.selecionados.unidade_id) {
                    profissionaisByUnidade.push(item);
                    diasByUnidade.push(moment(item.data_atendimento));
                }
            });

            this.$nextTick(() => {
                this.vagas_profissional = groupBy(profissionaisByUnidade, ["profissional_id"]);
                this.optionsCalendario.enabledDates = diasByUnidade;

                // let profissionalId = profissionaisByUnidade[0].profissional_id;
                // let indexProfissionalAtivo = String(profissionaisByUnidade[0].profissional_id);

                // this.selecionados.profissional_id = profissionalId;
                // this.selecionados.indexProfissionalAtivo = indexProfissionalAtivo;
                // this.selecionados.data = diasByUnidade[0]._id;

                this.getVagasDisponiveis();
            });
        },

        getDiasByUnidadeAndProfissional(index, profissionalId) {
            this.vagas_filtradas = [];
            this.selecionados.profissional_id = profissionalId;
            this.selecionados.indexProfissionalAtivo = index;

            let diasByUnidadeAndProfissional = [];

            this.vagas.map(item => {
                if (item.unidade_id == this.selecionados.unidade_id && item.profissional_id == this.selecionados.profissional_id) {
                    diasByUnidadeAndProfissional.push(moment(item.data_atendimento));
                }
            });

            this.$nextTick(() => {
                this.optionsCalendario.enabledDates = diasByUnidadeAndProfissional;
                // this.selecionados.data = diasByUnidadeAndProfissional[0];
                this.getVagasDisponiveis();
            });
        },

        getProfissionaisByUnidadeAndDia() {
            this.vagas_filtradas = [];
            let profissionaisByUnidadeAndDia = [];

            this.vagas.map(item => {
                if (item.unidade_id == this.selecionados.unidade_id && item.data_atendimento == this.selecionados.data) {
                    profissionaisByUnidadeAndDia.push(item);
                }
            });
            this.$nextTick(() => {
                this.vagas_profissional = groupBy(profissionaisByUnidadeAndDia, ["profissional_id"]);
                // this.selecionados.profissional_id = profissionaisByUnidadeAndDia[0].profissional_id;
                // this.selecionados.indexProfissionalAtivo = String(profissionaisByUnidadeAndDia[0].profissional_id);
                this.getVagasDisponiveis();
            });
        },

        getVagasDisponiveis() {
            if (this.selecionados.profissional_id && this.selecionados.unidade_id && this.selecionados.data) {
                this.vagas_filtradas = [];
                let vagasDisponiveis = [];
                this.vagas.map(item => {
                    if (item.unidade_id == this.selecionados.unidade_id && item.profissional_id == this.selecionados.profissional_id && item.data_atendimento == this.selecionados.data) {
                        vagasDisponiveis.push(item);
                    }
                });

                this.$nextTick(() => {
                    this.vagas_filtradas = vagasDisponiveis;
                    this.selecionados.indexVagaAtiva = 0;
                });
            }
        },

        selecionaVaga: function(index) {
            this.selecionados.indexVagaAtiva = index;
        },

        setIdadePaciente() {
            var hoje = new Date();
            var nascimento = new Date(this.dataNascimentoPaciente);
            var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
            if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) < new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())) {
                diferencaAnos--;
            }

            this.idadePacienteSelecionado = diferencaAnos;
        },

        buscarUnidade() {
            // let temp = [];
            // if (this.indexAtivoProfissional != undefined) {
            // 	var nmProfissionalSelecionado = this.listProfissionais[this.indexAtivoProfissional].nm_profissional;
            // }
            // this.listProfissionais.forEach((e, index, array) => {
            // 	if (e.nm_profissional.includes(this.nomeBuscaProfissional.toUpperCase())) {
            // 		temp.push(e);
            // 		array.splice(index, 1);
            // 	}
            // });
            // this.listProfissionais = [...temp, ...this.listProfissionais];
            // if (this.indexAtivoProfissional != undefined) {
            // 	var pos = this.listProfissionais.map(function (e) {
            // 		return e.nm_profissional;
            // 	}).indexOf(nmProfissionalSelecionado);
            // 	this.indexAtivoProfissional = pos;
            // }
        }
    },
    watch: {
        page: function(val) {
            this.getDataTable();
        },
        vagasApi: function(newValue) {
            if (newValue) {
                this.formataVagas();
                this.setIdadePaciente();
            } else {
                this.selecionados = {
                    unidade_id: null,
                    profissional_id: null,
                    indexUnidadeAtiva: null,
                    indexProfissionalAtivo: null,
                    indexVagaAtiva: null,
                    data: null
                };
                this.optionsCalendario = {
                    format: "YYYY-MM-DD",
                    useCurrent: false,
                    inline: true,
                    locale: "pt-br",
                    enabledDates: null,
                    defaultDate: false
                };

                this.vagas_unidade = [];
                this.vagas_profissional = [];
                this.vagas_filtradas = [];
                this.vagas = [];
            }
        }
    },

    components: {
        datePicker,
        modalEnviarRegulacao
    }
};
</script>

<style scoped>
.divListVagas {
    overflow: auto;
}
.listsVagas {
    list-style-type: none;
    display: inline;
    padding: 0px;
}

.listsVagas a {
    padding: 5px 10px 5px 10px;
    cursor: pointer;
}

.list-group-item {
    border-radius: 0px;
}

.tamanho-fixo-agenda-cima {
    display: block;
    height: 250px;
}

.ativa {
    background-color: #fdf59a !important;
    color: #333;
}

.ativa:hover {
    background-color: #fdf59a !important;
    color: #333;
}

.listbox {
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// resolucaoIndividual.vue?d2af79c8